import { useLayoutClass } from "@/modules/useLayoutClass"
import classes from "./styles.module.scss"

export type MenuItem = {
	Title: string
	Href: string
	ForceNewTab?: boolean
	Component: any
	ShowInMenu: boolean
}

export type Brand = {
	Title: string
	DefaultLayoutClass?: string
	Routes: MenuItem[]
	Page404: any
}

type Props = {
	Brand: Brand
	children: preact.ComponentChildren
}

export const LayoutMain = (props: Props) => {
	useLayoutClass(classes.html)

	if (props.Brand.DefaultLayoutClass) {
		useLayoutClass(props.Brand.DefaultLayoutClass)
	}

	const menuItems = props.Brand.Routes.filter((x) => {
		return x.ShowInMenu
	})
	return (
		<div className={classes.main}>
			<div className={classes.header}>
				<div className={classes.title}>{props.Brand.Title}</div>
				{menuItems.length > 0 && (
					<div className={classes.menu}>
						{menuItems.map((x) => {
							return (
								<a
									href={x.Href}
									target={
										x.Href.startsWith("http") || x.ForceNewTab
											? "_blank"
											: "_self"
									}
								>
									{x.Title}
								</a>
							)
						})}
					</div>
				)}
			</div>
			<div className={classes.body}>
				<article>{props.children}</article>
			</div>
		</div>
	)
}
